import { formatHtml } from "@trumpf/ux.common-storybook";
import { HomepageTemplate } from "./homepage.template";
import { renderPageTemplate } from "../../../utils";

//ToDo: should we stick everywhere just to 'args' & 'argTypes'?

const homepageStoryArgs = {
    sectionsSliderWithHeadline: true,
    withNewsroomBlock: false,
    sliderAutoHeight: true,
    noHiglightSlider: false,
    withInfoBanner: false,
};

const homepageStoryArgTypes = {
    sectionsSliderWithHeadline: {
        control: "boolean",
    },
    withNewsroomBlock: {
        control: "boolean",
    },
    sliderAutoHeight: {
        control: "boolean",
    },
    withInfoBanner: {
        control: "boolean",
    },
};

export default {
    title: "Website/Page Templates/Homepage",
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
        layout: "fullscreen",
    },
    args: { ...homepageStoryArgs },
    argTypes: { ...homepageStoryArgTypes },
};

export const Default = (args) =>
    renderPageTemplate(() => HomepageTemplate({ ...args }));
